'use client'

import { useEffect, useState } from 'react'
import { buildAttributedUrl } from '@/lib/attribution'

/**
 * A GHL booking-widget <iframe> whose src picks up page/CTA/UTM attribution
 * once mounted on the client. Renders the plain base URL for SSR/first paint,
 * then swaps in the attributed URL via useEffect — the widget itself just
 * reloads inside the same iframe once, which is fine for a booking calendar.
 */
export function AttributedCtaIframe({
  src,
  page,
  cta,
  title,
  className,
  style,
  loading,
  allow,
  onLoad,
}: {
  src: string
  page: string
  cta: string
  title: string
  className?: string
  style?: React.CSSProperties
  loading?: 'eager' | 'lazy'
  allow?: string
  onLoad?: () => void
}) {
  const [resolvedSrc, setResolvedSrc] = useState(src)

  useEffect(() => {
    setResolvedSrc(buildAttributedUrl(src, { page, cta }))
  }, [src, page, cta])

  return (
    <iframe
      src={resolvedSrc}
      title={title}
      className={className}
      style={style}
      loading={loading}
      allow={allow}
      onLoad={onLoad}
    />
  )
}
